import { useEffect, useRef, useState } from 'react';
import { useGameStore } from '../../core/store';
import './debug-hud.css';

/** Lightweight FPS / frame-time HUD — enable with ?debug=1 */
export function DebugHud() {
  const [fps, setFps] = useState(0);
  const [ms, setMs] = useState(0);
  const quality = useGameStore((s) => s.quality.id);
  const frames = useRef(0);
  const last = useRef(performance.now());
  const lastFrame = useRef(performance.now());

  useEffect(() => {
    let raf = 0;
    const loop = (now: number) => {
      frames.current += 1;
      setMs(Math.round((now - lastFrame.current) * 10) / 10);
      lastFrame.current = now;
      if (now - last.current >= 500) {
        setFps(Math.round((frames.current * 1000) / (now - last.current)));
        frames.current = 0;
        last.current = now;
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div className="debug-hud" aria-hidden>
      <span>{fps} FPS</span>
      <span>{ms} ms</span>
      <span>q:{quality}</span>
    </div>
  );
}

export function isDebugEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('debug') === '1';
}
